import { render } from "./BaseInputDate.vue?vue&type=template&id=5445e763&scoped=true&ts=true&lang=pug"
import script from "./BaseInputDate.vue?vue&type=script&lang=ts"
export * from "./BaseInputDate.vue?vue&type=script&lang=ts"

import "./BaseInputDate.vue?vue&type=style&index=0&id=5445e763&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./BaseInputDate.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./BaseInputDate.vue?vue&type=custom&index=1&blockType=i18n&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5445e763"]])

export default __exports__